import { RecommendationsCard } from './RecommendationsCard';
import type { RiskTier } from './RecommendationsCard';

interface RecommendationsModalProps {
  visible: boolean;
  onClose: () => void;
  tier: RiskTier;
  title: string;
  icon: React.ReactNode;
  bullets: string[];
}

export function RecommendationsModal({
  visible,
  onClose,
  tier,
  title,
  icon,
  bullets,
}: RecommendationsModalProps) {
  if (!visible) return null;

  return (
    <div
      className="animate-modal-backdrop fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4 backdrop-blur-lg"
      role="dialog"
      aria-modal="true"
      aria-labelledby="recommendations-modal-title"
      onClick={onClose}
    >
      <div
        className="animate-modal-content relative w-full max-w-md rounded-3xl bg-white/90 p-6 shadow-xl backdrop-blur-lg"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          onClick={onClose}
          className="absolute right-3 top-3 rounded p-1.5 text-[#5C5C5C] hover:bg-surface focus:outline-none focus:ring-2 focus:ring-primary"
          aria-label="Kapat"
        >
          <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
        <div className="pr-8">
          <RecommendationsCard tier={tier} title={title} icon={icon} bullets={bullets} />
        </div>
      </div>
    </div>
  );
}
